// eslint-disable-next-line no-unused-vars
import React from 'react';
import { Checkbox } from '@carbon/react';
import { func, bool } from 'prop-types';
import { useTranslation } from 'react-i18next';
import FilterListComponent from 'Components/Filters/FilterListComponent';

const AvailabilityFilter = ({ open, onToggle, onStockChange, onReservedStockChange, inStock, inStockReserved }) => {
  const { t } = useTranslation();
  return (
    <FilterListComponent
      onToggle={ onToggle }
      filterTitle={ t('filters.availability') }
      cx={ open ? 'open' : 'closed' }
      showSearch={ false }
    >
      <div className="options">
        <div className="filterItem">
          <Checkbox
            id="inStock"
            name="inStock"
            labelText={ t('filters.inStock') }
            checked={ inStock }
            onChange={ (_, { checked }) => onStockChange(checked) }
            disabled={ inStockReserved }
          />
        </div>
        <div className="filterItem">
          <Checkbox
            id="inStockReserved"
            name="inStockReserved"
            labelText={ t('filters.inStockReserved') }
            checked={ inStockReserved }
            onChange={ (_, { checked }) => onReservedStockChange(checked) }
          />
        </div>
      </div>
    </FilterListComponent>
  );
};

AvailabilityFilter.propTypes = {
  onToggle: func,
  onStockChange: func,
  onReservedStockChange: func,
  inStock: bool,
  inStockReserved: bool,
  open: bool
};

export default AvailabilityFilter;
